/*
 * Monta a parede de módulos auxiliares (ver
 * docs/specs/cma-modulos-auxiliares-3d.md §3): cada módulo entra ao lado do
 * último que já existe, na ordem de `AUX_PANEL_MODULES`, sem que os já
 * posicionados se movam quando um novo é adicionado.
 *
 * A parede é um grupo à parte, fora do carrossel — o modelo ATIVO do
 * carrossel sempre resolve para a origem do mundo, com rotação identidade
 * (ver setCarouselAngle/layoutCarousel em CmaAsset3dView.vue: a rotação do
 * anel é sempre cancelada pela contra-rotação do slot), então uma posição
 * fixa em coordenadas de mundo já acompanha o ativo em exibição sem
 * precisar ser filha do carrossel.
 */
import * as THREE from 'three';
import {
  AUX_PANEL_ORIGIN, AUX_PANEL_MARGIN, AUX_PANEL_MODULES, ESCALA_PRESENCA,
} from '@/domain/data/cma/auxiliaryPanelModels';
import { buildBm2 } from './bm2';

const BUILDERS = {
  bm2: buildBm2,
};

export function buildAuxPanelWall(materiais) {
  const group = new THREE.Group();
  group.name = 'aux-panel-wall';
  group.position.set(AUX_PANEL_ORIGIN.x, AUX_PANEL_ORIGIN.y, AUX_PANEL_ORIGIN.z);

  let cursorX = 0;
  AUX_PANEL_MODULES.forEach((id) => {
    const builder = BUILDERS[id];
    if (!builder) return;

    const modulo = builder(materiais);
    // cada builder devolve as medidas FÍSICAS de referência (§5 da spec) —
    // é aqui, num lugar só, que a escala de presença entra (§3.4), para
    // nenhum builder de módulo precisar saber dela
    modulo.group.scale.setScalar(ESCALA_PRESENCA);
    const width = modulo.width * ESCALA_PRESENCA;

    modulo.group.position.x = cursorX + width / 2;
    group.add(modulo.group);
    cursorX += width + AUX_PANEL_MARGIN;
  });

  return group;
}

export default buildAuxPanelWall;
